import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Self-hosted (no CDN) — the on-prem / air-gapped posture DESIGN.md requires.
import '@fontsource-variable/space-grotesk'   // display / instrument labels
import '@fontsource-variable/inter'           // body / UI / data
import '@fontsource/ibm-plex-mono/400.css'    // telemetry / numerics
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'

import './styles/tokens.css'
import App from './App.tsx'
import { connectWorld } from './lib/ws.ts'
import { installStaticNet } from './lib/static.ts'

// STATIC MODE first, and before anything can call `fetch`: on airsec.akeyo.io there is no
// backend, and every REST path in the app is rewritten onto the baked bundle by this one
// installer. It is a no-op on a live server.
installStaticNet()

// Open the world socket before the first render: the transport lives outside React entirely,
// so it starts streaming while the tree is still mounting.
connectWorld()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
